/* ══════════════════════════════════════════════════════════════
   Route Guards — Settings validation, etc.
   ══════════════════════════════════════════════════════════════ */

/**
 * Check if required API keys are configured
 * Used to show a setup prompt on first visit
 */
export function hasRequiredConfig(): boolean {
    // In prod, these would be server-side env vars
    // In dev, check if .env.local exists via a settings flag
    const settingsComplete = localStorage.getItem('imm_settings_complete');
    return settingsComplete === 'true';
}

/**
 * Mark settings as complete
 */
export function markSettingsComplete(): void {
    localStorage.setItem('imm_settings_complete', 'true');
}

/**
 * Get saved theme preference
 */
export function getThemePreference(): 'dark' | 'light' {
    return (localStorage.getItem('imm_theme') as 'dark' | 'light') || 'dark';
}

/**
 * Save theme preference
 */
export function setThemePreference(theme: 'dark' | 'light'): void {
    localStorage.setItem('imm_theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
}

/**
 * Get saved language preference
 */
export function getLanguagePreference(): string {
    return localStorage.getItem('imm_lang') || 'en';
}

/**
 * Save language preference
 */
export function setLanguagePreference(lang: string): void {
    localStorage.setItem('imm_lang', lang);
}
